import React, {useEffect, useRef, useState} from 'react';
import {Toast} from "primereact/toast";
import {UsePermissions} from "../../../hooks/usePermissions";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {AutoComplete} from "primereact/autocomplete";

import {UseLoader} from "../../../hooks/useLoader";
import {getAsociados} from "../../../api/liquidacionDeduccion.service";
import {devolverFondo, getFondos, getInfoFondos, saveFondosPend} from "../../../api/pagoFondos.service";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import {locales} from "../../../shared/types/constantes";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {convertirModena, error} from "../../../shared/utils/utils";
import NumberFormat from "react-number-format";
import {confirmDialog} from "primereact/confirmdialog";

export const PayTable = () => {
    addLocale('es', locales);
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const toast = useRef(null);

    const [isDateShow, setIsDateShow] = useState(false);
    const [fondosList, setFondosList] = useState([]);
    const [fondosTotal, setFondosTotal] = useState(0);

    const [fondos, setFondos] = useState([]);

    const [selectedFondo, setSelectedFondo] = useState({
        nombre: "",
        id: ""
    });

    const [FilteredFondo, setFilteredFondo] = useState(null);
    const [clientes, setClientes] = useState([]);

    const [selectedcliente, setSelectedcliente] = useState({
        nombre: "",
        id: ""
    });


    const [FilteredCliente, setFilteredCliente] = useState(null);

    const initParams = {
        fondo_id: '',
        asociado_id: '',
        tipo: '',
        fecha: new Date()
    };


    const [field, setField] = useState(initParams);

    const paramsSave = {
        fondo_id: '',
        asociado_id: '',
        valor: '',
        fecha: new Date()
    };
    const [fieldSave, setFieldSave] = useState(paramsSave);

    useEffect(() => {

        if (field.tipo === 'F') {
            setIsDateShow(true)
        } else {
            setIsDateShow(false)
        }

    }, [field]);


    useEffect(() => {
        getAsociados().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {

        };
    }, []);

    useEffect(() => {
        getFondos().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setFondos(r.data)
        }).catch(r => console.log(r))
        return () => {

        };
    }, []);

    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const searchFondo = (event) => {
        setTimeout(() => {
            let _filteredFondo;
            if (!event.query.trim().length) {
                _filteredFondo = [...fondos];
            } else {
                _filteredFondo = fondos.filter((fondo) => {
                    return fondo.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredFondo(_filteredFondo);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }


    const buscarFondos = async () => {
        try {
            handleLoad(true);
            const response = await getInfoFondos(field);
            handleLoad(false);
            if (response.estado !== 200) {
                setFondosList([]);
                setFondosTotal(0)
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }

            setFondosList(response.data.fondos);
            setFondosTotal(response.data.total)

        } catch (e) {
            handleLoad(false);
        }
    }

    const valorBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor);
    }

    const valorPagoBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor_pagado);
    }

    const submit = (e) => {
        e.preventDefault();
        try {
            if (field.tipo=== 'P' || field.tipo === 'F') {
                devolverPago()
            } else {
                if (fieldSave.valor === ''
                    || fieldSave.fecha === ''
                ) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "Validar campos",
                        life: 3000
                    });
                    return;
                }

                if (field.tipo !== 'A') {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "Solo se pueden pagar los fondos en estado pendiente",
                        life: 3000
                    });
                    return;
                }



                if (Number(fieldSave.valor) === 0) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "El valor debe ser mayor a cero",
                        life: 3000
                    });
                    return;
                }

                if (Number(fieldSave.valor) > Number(fondosTotal)) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "El valor asignado debe ser menor o igual al disponible",
                        life: 3000
                    });
                    return;
                }
                confirmDialog({
                    message: '¿Estas seguro?',
                    header: 'Confirmación',
                    acceptLabel: "Si",
                    rejectLabel: "No",
                    accept: async () => {
                        handleLoad(true)
                        const data = await saveFondosPend(fieldSave);
                        handleLoad(false)
                        if (data.estado !== 200) {
                            toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                            return;
                        }

                        toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});

                        setFieldSave({...fieldSave, valor: ''});
                        await buscarFondos();

                    }
                });
            }

        } catch (e) {
            console.log(e)
        }
    }

    const footer = (
        <div className="flex justify-around  ">
            <div className={"lg:w-8/12"}>
                <form onSubmit={ submit}>
                    <ContainerGroupForm width="lg:w-6/12">
                        <label
                            className="label-form"
                            htmlFor="fcha"
                        >
                            {field.tipo ==='A' ? 'Fecha liquidación *' : 'Fecha fondo a devolver *'}
                        </label>

                        <Calendar id="fechacrea"
                                  value={fieldSave.fecha}
                                  locale="es"
                                  monthNavigator={true}
                                  yearNavigator={true}
                                  yearRange='2010:2030'
                                  dateFormat="yy-mm-dd"
                                  style={{width: "100%"}}
                                  onChange={(e) => setFieldSave({...fieldSave, fecha: e.value})} showIcon/>
                        {error(fieldSave.fecha, 'required')}
                    </ContainerGroupForm>

                    {field.tipo === 'A' && <div className="row">
                        <ContainerGroupForm width="lg:w-6/12">
                            <label
                                className="label-form"
                                htmlFor="porcentaje"
                            >
                                Valor *
                            </label>
                            <NumberFormat
                                id="valor"
                                thousandsGroupStyle="thousand"
                                value={fieldSave.valor}
                                prefix="$"
                                displayType="input"
                                type="text"
                                decimalSeparator="."
                                className="form-input-small"
                                thousandSeparator={true}
                                allowNegative={false}
                                onValueChange={(e) => setFieldSave({...fieldSave, valor: e.value})}
                            />

                            {error(fieldSave.valor, 'required')}
                        </ContainerGroupForm>
                        <ContainerGroupForm width="lg:w-6/12">
                            <div className="mt-6 relative w-full px-4">
                                <button
                                    className="secundary-color-btn btn w-full"
                                    type={'submit'}
                                >
                                    Guardar
                                </button>
                            </div>
                        </ContainerGroupForm>
                    </div>}

                    {(field.tipo === 'P' || field.tipo === 'F') && <div className="row">
                        <ContainerGroupForm width="lg:w-6/12">
                            <div className="mt-6 relative w-full px-4">
                                <button
                                    className="secundary-color-btn btn w-full"
                                    type={'submit'}
                                >
                                    Devolver fondo
                                </button>
                            </div>
                        </ContainerGroupForm>
                    </div>}
                </form>
            </div>
            <p className="p-2  text-sm"> Total : {convertirModena(fondosTotal)}</p>
        </div>
    );

    const setFieltsPres = (id) => {
        setField({...field, fondo_id: id})
        setFieldSave({...fieldSave, fondo_id: id})
    }

    const setFieltsAsoc = (id) => {
        setField({...field, asociado_id: id})
        setFieldSave({...fieldSave, asociado_id: id})
    }

    const devolverPago = () =>  {
        try {
            if (field.tipo === 'A') {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Solo se pueden devolver fondos en pagados",
                    life: 3000
                });
                return;
            }

            if (field.fondo_id === '') {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Seleccione el tipo de fondo",
                    life: 3000
                });
                return;
            }

            if (field.asociado_id === '') {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Seleccione el afiliado",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const payload = {
                        asociado_id: field.asociado_id,
                        fondo_id: field.fondo_id,
                        fecha: fieldSave.fecha
                    }

                    const data = await devolverFondo(payload);
                    handleLoad(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});

                    setFieldSave({...fieldSave, valor: ''});
                    await buscarFondos();

                }
            });
        }catch (e) {
            console.log(e)
        }
    }

   /* const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() =>  devolverPago(rowData)}>
                    <i className="fa fa-user-edit"/>
                </button>
            </div>
        );
    }*/

    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <div className=" flex flex-wrap items-center  p-4 primary-color">

                {permisos.consultar === 1 && fondos.length > 0 ?
                    <div className=" mt-2 relative lg:w-4/12 px-4">
                        <AutoComplete value={selectedFondo} suggestions={FilteredFondo}
                                      style={{"width": "100%"}}
                                      completeMethod={searchFondo}
                                      placeholder="Buscador Fondo"
                                      size="30"
                                      field="nombre" dropdown itemTemplate={itemTemplate}
                                      onSelect={(e) => setFieltsPres(e.value.id)}
                                      onChange={(e) => setSelectedFondo(e.value)}/>
                    </div>
                    : ""}
                {permisos.consultar === 1 && clientes.length > 0 ?
                    <div className=" mt-2 relative lg:w-4/12 px-4">
                        <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                      style={{"width": "100%"}}
                                      completeMethod={searchCliente}
                                      placeholder="Buscador afiliados"
                                      size="30"
                                      field="nombre" dropdown itemTemplate={itemTemplate}
                                      onSelect={(e) => setFieltsAsoc(e.value.id)}
                                      onChange={(e) => setSelectedcliente(e.value)}/>
                    </div>
                    : ""}


                <ContainerGroupForm width="lg:w-3/12">
                    <label
                        className="label-form text-white"
                        htmlFor="anio"
                    >
                        Tipo *
                    </label>
                    <select value={field.tipo} name="periodo"
                            className="form-input"
                            onChange={(e) => setField({...field, tipo: e.target.value})}
                            id="tipo">
                        <option value="">Seleccione...</option>
                        <option value="A">Pagos pendientes</option>
                        <option value="P">Pagados</option>
                        <option value="F">Pagados con fecha</option>
                    </select>

                </ContainerGroupForm>

                {isDateShow && <ContainerGroupForm width="lg:w-3/12">
                    <Calendar id="fecha"
                              value={new Date(field.fecha)}
                              locale="es"
                              style={{width: "100%"}}
                              monthNavigator={true}
                              yearNavigator={true}
                              yearRange='2010:2030'
                              dateFormat="yy-mm-dd"
                              onChange={(e) => setField({...field, fecha: e.value})} showIcon/>
                </ContainerGroupForm>}
                <ContainerGroupForm width="lg:w-3/12">
                    <div className="mt-6 relative w-full px-4">
                        <button
                            className="warning-color-btn btn w-full"
                            onClick={buscarFondos}
                        >
                            Buscar
                        </button>
                    </div>

                </ContainerGroupForm>

            </div>

            <ContainerTable>
                <DataTable
                    showGridlines
                    resizableColumns

                    columnResizeMode="expand"
                    footer={footer}
                    size="small"
                    scrollable
                    scrollHeight="400px"
                    value={fondosList}

                    responsiveLayout="scroll">

                    <Column field="fecha" sortable filter header="Fecha" showFilterMatchModes={false}
                    ></Column>
                    <Column field="fecha_pago" sortable filter header="Fecha pago" showFilterMatchModes={false}
                    ></Column>
                    <Column field="nombre" sortable filter header="Cliente" showFilterMatchModes={false}
                    ></Column>
                    <Column field="valor" header="Valor" sortable filter body={valorBodyTemplate}
                            showFilterMatchModes={false}
                    >
                    </Column>

                    <Column field="valor_pagado" header="Valor pagado" sortable filter body={valorPagoBodyTemplate}
                            showFilterMatchModes={false}
                    >
                    </Column>


                    <Column field="estado" header="Estado" sortable filter
                            showFilterMatchModes={false}
                    >
                    </Column>

                    {/*{(field.tipo === 'P' || field.tipo === 'F')  &&    <Column header="Devolver pago" style={{fontSize: ".8em"}} body={actionTemplate}></Column>}*/}


                </DataTable>
            </ContainerTable>

        </>
    );
};


